import SearchItem from './SearchItem';

export default SearchItem;
